module.exports = __webpack_public_path__ + "static/media/emptystateactivity.d8e0595e.svg";